import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { isValidValue } from "../index";
dayjs.extend(utc);
dayjs.extend(timezone);
const dateTypeMap = {
  date: "YYYY-MM-DD",
  datetime: "YYYY-MM-DD HH:mm:ss",
  datetimeDot: "YYYY.MM.DD HH:mm:ss",
  time: "HH:mm:ss"
};
var TimeZone = /* @__PURE__ */ ((TimeZone2) => {
  TimeZone2["CN"] = "Asia/Shanghai";
  TimeZone2["SG"] = "Asia/Singapore";
  TimeZone2["EU"] = "Europe/Istanbul";
  TimeZone2["US"] = "America/Los_Angeles";
  return TimeZone2;
})(TimeZone || {});
const formatDate = (value, format = "datetime") => {
  if (!isValidValue(value)) {
    return "-";
  }
  let newValue = value;
  if (typeof value === "string" && /^\d+$/.test(value)) {
    newValue = parseInt(value, 10);
  }
  return dayjs(newValue).format(dateTypeMap[format]);
};
const formatDateRange = (value, format) => {
  if (!isValidValue(value[0]) && !isValidValue(value[1])) {
    return "-";
  }
  return `${formatDate(value[0], format)} ~ ${formatDate(value[1], format)}`;
};
const getLastDays = (number, { includeToday = true } = {}) => {
  const today = dayjs();
  const subtractDays = includeToday ? 0 : 1;
  return Array.from(
    { length: number },
    (_, i) => today.subtract(i + subtractDays, "day").valueOf()
  );
};
const convertDateTimeZone = (dateTime, sourceTimeZone, targetTimeZone, format) => {
  if (!sourceTimeZone || !targetTimeZone) {
    throw new Error("sourceTimeZone and targetTimeZone are required");
  }
  let newDateTime;
  if (typeof dateTime === "string" || typeof dateTime === "number") {
    newDateTime = dayjs.tz(dateTime, sourceTimeZone).tz(targetTimeZone);
  } else if (dayjs.isDayjs(dateTime)) {
    newDateTime = dateTime.tz(sourceTimeZone).tz(targetTimeZone);
  } else {
    throw new Error("Unsupported input type for convertDateTimeTimeZoneByDayJs");
  }
  return formatDate(newDateTime, format);
};
const transformDateFromServerToClient = (dateTime, serverTimeZone, format) => {
  const clientTimeZone = dayjs.tz.guess();
  return convertDateTimeZone(
    dateTime,
    serverTimeZone,
    clientTimeZone,
    format
  );
};
const transformDateFromClientToServer = (dateTime, serverTimeZone, format) => {
  const clientTimeZone = dayjs.tz.guess();
  return convertDateTimeZone(
    dateTime,
    clientTimeZone,
    serverTimeZone,
    format
  );
};
export {
  TimeZone,
  formatDate,
  formatDateRange,
  getLastDays,
  transformDateFromClientToServer,
  transformDateFromServerToClient
};
